import React from "react";
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom"; // For navigation
import { CardMedia } from "@mui/material";
import CustomButton from "../../Components/Atoms/CustomButton";
import { ACCESS_DENIED } from "../../Constant";

// You can replace this with your own image URL
const errorImage = "https://via.placeholder.com/400"; // Example image URL

const Forbidden = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Goes back to the previous page
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      minHeight="100vh"
      bgcolor="#f5f5f5"
      padding={3}
    >
      <Card sx={{ maxWidth: 600, boxShadow: 3 }}>
        <CardMedia
          component="img"
          height="200"
          image={ACCESS_DENIED}
          alt="Forbidden Access"
        />
        <CardContent>
          <h2>403 - UNAUTHORIZED ACCESS</h2>
          <p className="mb-2">
            The resource you are looking for is unauthorized.
          </p>
          <p className="mb-2">
            You do not have permission to access this page. Please contact your
            administrator.
          </p>

          <CustomButton
            label={"GO BACK"}
            action={"BACK"}
            btnType="primary"
            onClick={handleGoBack}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default Forbidden;
